export const api = {
  questionManage: { // 调查问卷管理
    queryAllQuestionList: '/bms/queryQuestion/queryAllQuestionList', // 查询所有的调查项
    queryAllPersonnelList: '/bms/queryQuestion/queryAllPersonnelList', // 查询所有的人员信息
    addQuestionnaire: '/bms/addQuestionnaire/addQuestionnaire', // 新增问卷调查信息
    updateQuestionnaire: '/bms/addQuestionnaire/updateQuestionnaire', // 修改问卷调查信息
    deleteQuestionnaire: '/bms/addQuestionnaire/deleteQuestionnaire', // 删除调查问卷信息
    queryQuestionnaire: '/bms/queryQuestionnaire/queryQuestionnaire', // 查询单条调查问卷信息
    publishQuestionnaire: '/bms/addQuestionnaire/publishQuestionnaire', // 发布调查问卷信息
    queryQuestionnaireList: '/bms/queryQuestionnaire/queryQuestionnaireList', // 分页查询调查问卷信息
  },
  surveyManage: { // 调查项管理
    addQuestion: '/bms/addQuestion/addQuestion', // 新增问卷项（问题）信息
    updateQuestion: '/bms/addQuestion/updateQuestion', // 修改问卷项（问题）信息
    deleteQuestion: '/bms/addQuestion/deleteQuestion', // 删除问题信息
    queryQuestionList: '/bms/queryQuestion/queryQuestionList', // 分页查询问题信息
    addQuestionCategory: '/bms/addQuestionCategory/addQuestionCategory', // 添加问题分类信息
    updateQuestionCategory: '/bms/addQuestionCategory/updateQuestionCategory', // 修改问题分类信息
    deleteQuestionCategory: '/bms/addQuestionCategory/deleteQuestionCategory', // 删除问题分类信息
    queryQuestionCategoryList: '/bms/queryQuestionCategory/queryQuestionCategoryList', // 查询所有问题分类信息列表
  },
  display: {
    energyConsumptionStatistics: '/bms/energyMeterDataInfo/energyConsumptionStatistics', // 用能统计
    getBuildList: '/bms/energyMeterInfo/getBuildList', // 公用建筑下拉框
    todayConsumption: '/bms/energyMeterDataInfo/todayBuildenergyConsumption', // 今日建筑用电柱状图
    historyConsumption: '/bms/energyMeterDataInfo/historyBuildenergyConsumption', // 历史趋势统计
    historyConsumptionOfMonth: '/bms/energyMeterDataInfo/historyBuildenergyConsumptionOfMonth', // 历史趋势统计
  },
  forewarning: {
    queryEnergyConsumptionWarningList: '/bms/energyConsumptionWarning/queryEnergyConsumptionWarningList', // 能耗预警列表查询
    getBuildEnergyConsumption: '/bms/energyMeterDataInfo/getBuildenergyConsumption', // 同期能耗查询
    addEnergyConsumptionWarning: '/bms/energyConsumptionWarning/addEnergyConsumptionWarning', // 新增能耗预警
    editEnergyConsumptionWarning: '/bms/energyConsumptionWarning/editEnergyConsumptionWarning', // 修改能耗预警
    removeEnergyConsumptionWarning: '/bms/energyConsumptionWarning/removeEnergyConsumptionWarning', // 批量删除能耗预警
    queryEnergyVfpConsumptionWarningList: 'bms/energyVfpConsumptionWarning/queryEnergyVfpConsumptionWarningList',
    addEnergyVfpConsumptionWarning: '/bms/energyVfpConsumptionWarning/addEnergyVfpConsumptionWarning',
    editEnergyVfpConsumptionWarning: '/bms/energyVfpConsumptionWarning/editEnergyVfpConsumptionWarning',
    removeEnergyVfpConsumptionWarning: '/bms/energyVfpConsumptionWarning/removeEnergyVfpConsumptionWarning',
  },
  alarm: {
    queryEnergyConsumptionAlarmList: '/bms/energyConsumptionAlarm/queryEnergyConsumptionAlarmList',
    sendMessage: '/bms/energyMeterDataInfo/sendMessage',
    queryEnergyConsumptionVfpAlarmList: '/bms/energyConsumptionAlarm/queryEnergyConsumptionVfpAlarmList'
  },
  meterIndicator: {
    queryEnergyMeterTree: '/bms/energyMeterInfo/queryEnergyMeterTree',
    getEnergyMeterDataOfDay: '/bms/energyMeterDataInfo/getenergyMeterDataOfDay',
    exportMeterDataOfDay: '/bms/energyMeterDataInfo/exportMeterDataOfDay',
    todayMeterConsumption: '/bms/energyMeterDataInfo/todayMeterConsumption',
    trendAnalysisOfVfp: '/bms/energyMeterDataInfo/trendAnalysisOfVfp',
  },
  gfpWarning: {
    getEnergyMeterData: '/bms/energyMeterDataInfo/getenergyMeterRecoreData',
    exportVpfDataOfDay: '/bms/energyMeterDataInfo/exportVpfDataOfDay'
  },
  waterRecord: {
    queryMeterList: '/bms/water/meter/page.json',
    addMeter: '/bms/water/meter/add.json',
    addSingleRecord: '/bms/water/meter/record/add.json',
    queryBatchRecord: '/bms/water/meter/list.json',
    addBatchRecord: '/bms/water/meter/record/batch/add.json',
    queryDetailList: '/bms/water/meter/record/list.json',
    updateSingleRecord: '/bms/water/meter/record/update.json',
    personList: '/bms/water/meter/record/person/list.json',
    querySingleRecord: '/bms/water/meter/record/getMaxAndMinRecord.json',
    queryFormRecord: '/bms/water/meter/list.json',
  }
}
